//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { userMixin } from '@/mixins/user';
import WorkEnvironmentsService from '@/services/work_env_service';
import FormResourceResponseComponent from '@/apps/analytic-services/components/FormResourceResponseComponent';
import DialogsComponent from '@/components/DialogsComponent';
import utils from '@/utils/firebase';
var firebaseDataOperation = utils.getFirebaseDataOperation();
export default {
  name: 'ResourcesRequestPage',
  mixins: [userMixin],
  components: {
    FormResourceResponseComponent: FormResourceResponseComponent,
    DialogsComponent: DialogsComponent
  },
  data: function data() {
    return {
      MODAL_RESPONSE_RESOURCE: 'MODAL_RESPONSE_RESOURCE',
      STATUS_PROCESSING: 'PROCESSING',
      STATUS_ERROR: 'ERROR',
      TYPE_UPDATE: 'UPDATE ENVIRONMENT',
      TYPE_CREATE: 'CREATE ENVIRONMENT',
      isBusy: false,
      fields: [{
        key: 'user_email',
        label: 'Applicant'
      }, {
        key: 'business_case',
        label: 'Business Case'
      }, {
        key: 'company',
        label: 'Company'
      }, {
        key: 'pr_firebase',
        label: 'Project Firebase'
      }, {
        key: 'pr_gcp',
        label: 'Project GCP'
      }, {
        key: 'requested_date',
        label: 'Request Time'
      }, {
        key: 'status',
        label: 'Status',
        class: 'text-center'
      }, {
        key: 'actions',
        label: 'Actions',
        class: 'text-center'
      }],
      items: [],
      item: {},
      datastudio_url: 'https://datastudio.google.com/reporting/79642cfb-cf75-43cc-a959-9ed0aa6bd44b/page/pC5OC?s=mtWuUZiL9Cw',
      key_table: 1
    };
  },
  created: function created() {
    this.subscribeObserver();
  },
  beforeDestroy: function beforeDestroy() {
    this.unsubscribeObserver();
  },
  methods: {
    getResourcesRequests: function getResourcesRequests() {
      var _this = this;
      this.isBusy = true;
      var params = {
        domain: this.userDomain
      };
      WorkEnvironmentsService.getResourcesRequests(params).then(function (response) {
        _this.items = response.data;
        _this.isBusy = false;
      });
    },
    viewDetail: function viewDetail(item) {
      this.item = item;
      // this.$bvModal.show(this.MODAL_RESPONSE_RESOURCE)
      this.$refs[this.MODAL_RESPONSE_RESOURCE].onOpen();
    },
    onProccess: function onProccess(documentId) {
      var callback = function callback(item) {
        return item.doc_id === documentId;
      };
      var index = this.items.findIndex(callback);
      var edit = this.items.find(callback);
      edit.status = this.STATUS_PROCESSING;
      this.$set(this.items, index, edit);
      this.$refs[this.MODAL_RESPONSE_RESOURCE].onClose();
    },
    getMachinesRequestedCollection: function getMachinesRequestedCollection() {
      var db = firebaseDataOperation.firestore();
      var ref = db.collectionGroup('machines_requested');
      return ref;
    },
    subscribeObserver: function subscribeObserver() {
      var _this2 = this;
      this.getResourcesRequests();
      var docRef = this.getMachinesRequestedCollection();
      docRef.onSnapshot(function (querySnapshot) {
        querySnapshot.docChanges().forEach(function (change) {
          if (change.type === 'modified') {
            var callback = function callback(item) {
              return item.doc_id === change.doc.id;
            };
            var index = _this2.items.findIndex(callback);
            if (index !== -1) {
              var edit = change.doc.data();
              _this2.$set(_this2.items, index, edit);
              console.log(edit);
            }
          }
        });
      });
      console.log('Subscribe Observer');
    },
    unsubscribeObserver: function unsubscribeObserver() {
      var docRef = this.getMachinesRequestedCollection();
      docRef.onSnapshot(function () {});
      console.log('Unsubscribe observer');
    }
  },
  computed: {
    headers: function headers() {
      return [{
        text: this.translate('table_my_work_envs.applicant'),
        value: 'user_email'
      }, {
        text: this.translate('table_my_work_envs.project_gcp'),
        value: 'business_case'
      }, {
        text: this.translate('table_my_work_envs.company'),
        value: 'company'
      }, {
        text: this.translate('table_my_work_envs.pr_firebase'),
        value: 'pr_firebase'
      }, {
        text: this.translate('table_my_work_envs.project_gcp'),
        value: 'pr_gcp'
      }, {
        text: this.translate('table_my_work_envs.requested_date'),
        value: 'requested_date'
      }, {
        text: this.translate('table_my_work_envs.status'),
        value: 'status'
      }, {
        text: this.translate('table_my_work_envs.actions'),
        value: 'actions'
      }];
    },
    statusColor: function statusColor() {
      var _this3 = this;
      return function (instance) {
        var status = instance.status;
        return status === _this3.STATUS_ERROR ? 'red' : status === _this3.STATUS_PROCESSING ? 'info' : 'warning';
      };
    }
  }
};